import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/legal.css';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  const sections = t('privacyPolicyPage.sections', { returnObjects: true });

  return (
    <div className="legal-page">
      <div className="container">
        <h1>{t('privacyPolicyPage.title')}</h1>
        <p className="legal-last-updated">{t('privacyPolicyPage.lastUpdated')}</p>
        <p className="legal-intro">{t('privacyPolicyPage.intro')}</p>

        {sections.map((section, index) => (
          <section key={section.title} className="legal-section">
            <h2>{section.title}</h2>
            {section.paragraphs.map((paragraph, idx) => (
              <p key={`${section.title}-${idx}`}>{paragraph}</p>
            ))}
          </section>
        ))}

        <p className="legal-contact">{t('privacyPolicyPage.contact')}</p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;

